import React from "react";
import { useViewport } from "js/hooks/useViewport";

import PageMeta from "core/PageMeta";
import SectionContainer from "core/SectionContainer";
import BulletSection from "core/BulletSection";
import OffsetGrid from "core/OffsetGrid";
import HeroLandingPage from "core/HeroLandingPage";
import Collections from "core/Collections";
import BlogPosts from "core/BlogPosts";
import PhotosSection from "marketing-pages/PricingMarketingPage/PhotosSection";

import colors from "core/colors";

import {
    heroImages,
    heroHeading,
    heroSearchPlaceholder,
    bullets,
    collectionsTitle,
    collections,
    pillsTitle,
    pills,
    featuredTitle,
    features
} from "./data";
import { placeholderText } from "./helpers";

const PhotosLanding = () => {
    const { browserWidth } = useViewport();
    const placeholder = placeholderText({
        browserWidth,
        searchPlaceholderText: heroSearchPlaceholder
    });

    return (
        <>
            <PageMeta
                title="Stock Photos & Royalty-Free Images | Noun Project"
                description="Noun Project is building the best and most useful collection of stock photos. Browse a variety of royalty-free images representing a more inclusive world."
                indexContent="index,follow,max-image-preview:large"
            />
            <SectionContainer
                bgColor={colors.secondary.orca}
                textColor={colors.primary.diamond}
                topSpacing="none"
                bottomSpacing="4xl"
            >
                <OffsetGrid sm={10} md={12} lg={12}>
                    <HeroLandingPage
                        heroImages={heroImages}
                        heading={heroHeading}
                        placeholder={placeholder}
                        headingColor={colors.primary.snow}
                        bgSizeTablet="100%"
                        bgPositionTablet="100% bottom"
                    />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <BulletSection bullets={bullets} hasMobileOffsetOneCol />
                </OffsetGrid>
            </SectionContainer>

            <SectionContainer
                bgColor={colors.primary.diamond}
                textColor={colors.secondary.orca}
            >
                <Collections
                    title={collectionsTitle}
                    collections={collections}
                    pillsTitle={pillsTitle}
                    pills={pills}
                    hasTitleOffset
                />
            </SectionContainer>

            <SectionContainer>
                <OffsetGrid sm={10} md={12} lg={12}>
                    <BlogPosts
                        blogPostsTitle={featuredTitle}
                        posts={features}
                    />
                </OffsetGrid>
            </SectionContainer>

            <PhotosSection hideNounProjectHeading />
            {/* ^ this component contains a SectionContainer on account of a page anchor */}
        </>
    );
};

export default PhotosLanding;
